var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"95fc33251f7648ae15d7e1b4d23cc2d3486b0ce8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rcsa@gum-technologies-6m"]={id:"95fc33251f7648ae15d7e1b4d23cc2d3486b0ce8"};
      